import React from 'react';
import { ShieldCheckIcon, HeartHandshakeIcon, AwardIcon, ClockIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { AboutSection } from '../components/sections/AboutSection';
import { StatsBand } from '../components/sections/StatsBand';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/fx/Reveal';
const values = [{
  icon: ShieldCheckIcon,
  title: 'Integrity First',
  text: 'Honest assessments, transparent pricing, and work we stand behind — always.'
}, {
  icon: HeartHandshakeIcon,
  title: 'Family Focused',
  text: 'We treat every home like our own and every family like our neighbors.'
}, {
  icon: AwardIcon,
  title: 'Craftsmanship',
  text: 'Luxury-grade finishes and structural excellence on every single project.'
}, {
  icon: ClockIcon,
  title: 'Always Ready',
  text: "True 24/7 emergency response when disaster can't wait until morning."
}];
export function About() {
  return <>
      <PageHero eyebrow="Our Story" title="Built on Trust. Driven by Craft." subtitle="Dream Shield is Houston's premium restoration and construction partner — combining rapid response with the artistry of a luxury builder." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'About'
    }]} data-id="element-401" data-mp="1pjql4g3pypzc" />
      <StatsBand data-id="element-402" data-mp="28gru0c0e9a8k" />
      <AboutSection data-id="element-403" data-mp="28hb27108sk9e" />
      <section className="mx-auto max-w-7xl px-6 py-24" data-id="element-404" data-mp="2m8y9rwzmxf7h">
        <SectionHeading eyebrow="What Drives Us" title="Our Core Values" data-id="element-405" data-mp="2m7obb6ove50b" />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-406" data-mp="2i74clyonetc2">
          {values.map((v, i) => <Reveal key={v.title} delay={i * 0.08} data-id="element-407" data-mp="2w86zgdngw7o1" data-mpi={i}>
              <div className="gradient-border h-full rounded-4xl p-7 shadow-glass" data-id="element-408" data-mp="2r82hskatp6w8">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-royal/10 text-royal" data-id="element-409" data-mp="2r5y63g6on3le">
                  <v.icon className="h-7 w-7" strokeWidth={1.8} data-id="element-410" data-mp="1sw7zh77ptks3" />
                </div>
                <h3 className="mt-6 font-display text-lg font-bold text-navy" data-id="element-411" data-mp="1su58okyqnnmb">
                  {v.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-412" data-mp="22lrlumumzwrp">
                  {v.text}
                </p>
              </div>
            </Reveal>)}
        </div>
      </section>
      <EmergencyCTA data-id="element-413" data-mp="2cjyyithw7snw" />
    </>;
}